import('./config/cookies.mock');
import('./bootstrap');
